import { render } from "./NotificationHandler.vue?vue&type=template&id=4ad9ceba&scoped=true"
import script from "./NotificationHandler.vue?vue&type=script&lang=js"
export * from "./NotificationHandler.vue?vue&type=script&lang=js"

import "./NotificationHandler.vue?vue&type=style&index=0&id=4ad9ceba&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad9ceba"]])

export default __exports__